module.exports = __webpack_public_path__ + "static/media/kashio.76c472d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/kashio.png
// module id = 1675
// module chunks = 0